
























































import Vue from "vue";
import { Canvg, presets } from "canvg";
import { Card, Icon } from "ant-design-vue";
import SvgLogo from "@/assets/logo.svg";
import SvgLogoGold from "@/assets/logo-gold.svg";
import SvgLogoBlack from "@/assets/logo-black.svg";
import SvgLogoHeaderBlack from "@/assets/img/menu/header-logo-black.svg";
import SvgLogoHeaderWhite from "@/assets/img/menu/header-logo-white.svg";
import SvgLogoHeaderBlackWrap from "@/assets/img/menu/header-logo-black-wrap.svg";
import SvgLogoHeaderWhiteWrap from "@/assets/img/menu/header-logo-white-wrap.svg";

const preset = presets.offscreen();

export default Vue.extend({
  name: "MediaKit.Index",
  data() {
    return {
      images: {
        latest: [
          {
            url: SvgLogo,
            theme: "light",
            filename: "logo-legend.svg"
          },
          {
            url: SvgLogoHeaderBlack,
            theme: "light",
            filename: "logo-legend-black.svg"
          },
          {
            url: SvgLogoHeaderWhite,
            theme: "dark",
            filename: "logo-legend-white.svg"
          },
          {
            url: SvgLogoHeaderBlackWrap,
            theme: "light",
            filename: "logo-legend-black-alt.svg"
          },
          {
            url: SvgLogoHeaderWhiteWrap,
            theme: "dark",
            filename: "logo-legend-white-alt.svg"
          }
        ],
        legacy: [
          {
            url: SvgLogoGold,
            theme: "light",
            filename: "legacy-logo-legend-gold.svg"
          },
          {
            url: SvgLogoBlack,
            theme: "light",
            filename: "legacy-logo-legend-black.svg"
          },
          {
            url: `${process.env.BASE_URL}img/logo-legend-001.png`,
            theme: "light",
            filename: "legacy-logo-legend-001.png"
          },
          {
            url: `${process.env.BASE_URL}img/logo-legend-002.png`,
            theme: "light",
            filename: "legacy-logo-legend-002.png"
          },
          {
            url: `${process.env.BASE_URL}img/logo-legend-003.png`,
            theme: "light",
            filename: "legacy-logo-legend-003.png"
          }
        ]
      }
    };
  },
  components: {
    [Card.name]: Card,
    [Icon.name]: Icon
  },
  methods: {
    async fetchImageData(src = "") {
      const req = new Request(src);
      const resp = await fetch(req);
      const blob = await resp.blob();
      const objectURL = URL.createObjectURL(blob);

      return objectURL;
    },
    async getImageSize(src = ""): Promise<HTMLImageElement> {
      return new Promise((resolve, reject) => {
        const $img = document.createElement("img");
        $img.onload = function() {
          resolve(this as HTMLImageElement);
        };
        $img.onerror = reject;
        $img.src = src;
      });
    },
    async toPng(data: any) {
      const { width, height, svg } = data;
      const canvas = new OffscreenCanvas(width, height);
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        throw new Error("context 2d not found.");
      }
      const v = await Canvg.from(ctx, svg, preset);

      v.resize(width, height, "xMidYMid meet");

      await v.render();

      const blob = await canvas.convertToBlob();
      const pngUrl = URL.createObjectURL(blob);

      return pngUrl;
    },
    handleDownload(url = "", filename = "") {
      const $el = document.createElement("a");
      $el.href = url;
      $el.download = filename;
      $el.click();
      URL.revokeObjectURL(url);
    },
    async onImageDownload(url = "", filename = "") {
      const objectURL = await this.fetchImageData(url);
      this.handleDownload(objectURL, filename);
    },
    async onPngDownload(url = "", filename = "") {
      const image = await this.getImageSize(url);
      const data = window.prompt(
        "Please input a size (width,height):",
        `${image.width},${image.height}`
      );
      if (data) {
        const [width, height] = data.split(/\W+/);
        const objectURL = await this.toPng({ width, height, svg: url });
        this.handleDownload(objectURL, filename);
      } else {
        // abort download
      }
    }
  },
  created() {}
});
